export default {
    chat: {
        dialog: {
            label: 'CHAT-SITZUNG',
            newConversation: 'Neues Gespräch',
        },
        header: {
            title: 'NOCWARE KI-AGENT',
            subtitle: 'Frag mich alles zu deinen Projekten, Standorten oder Geräten!',
        },
        input: {
            placeholder: 'Nachricht eingeben',
            stop: 'Antwort stoppen',
        },
        error: {
            connectionFailed:
                'Server nicht erreichbar. Bitte überprüfe deine Verbindung und versuche es erneut.',
            unauthorized: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
            streamInterrupted: 'Die Antwort wurde unterbrochen. Bitte versuche es erneut.',
            httpError:
                'Etwas ist schiefgelaufen (Fehler {status}). Bitte versuche es in einem Moment erneut.',
        },
    },
};
